import React from 'react';
import Text from "../../img/sammi-login-logo.png";

interface SammiLogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const SammiLogo: React.FC<SammiLogoProps> = ({ className = '', size = 'medium' }) => {
  const sizeClasses = {
    small: 'h-16 md:h-20',
    medium: 'h-20 md:h-32',
    large: 'h-24 md:h-40'
  };

  return (
    <div className={`flex flex-shrink-0 items-center justify-center mb-4 md:mb-6 ${className}`}>
      <img 
        className={`block ${sizeClasses[size]} w-auto`} 
        src={Text} 
        alt="SAMMi Logo" 
      />
    </div>
  );
};

export default SammiLogo;
